import { loadImages } from '../img/img';
import { roomLayersWeights } from '../../constants/components/scenes/elf/settings';

export async function saveRoomAsBase64(profile, options, debug = false) {
  try {
    return await _saveRoomAsBase64(profile, options, debug);
  } catch (e) {
    console.error(e);
  }
  return null;
}

export async function _saveRoomAsBase64(
  profile,
  options = {
    size: { width: 1024, height: 1024 },
    elfSize: { width: 400, height: 400, offset: { x: 0, y: 20 } },
  },
  debug = false,
) {
  const canvas = document.getElementById('saveRoomAsBase64') || document.createElement('canvas');
  canvas.setAttribute('id', 'saveRoomAsBase64');

  const ctx = canvas.getContext('2d');

  // if (debug)
  //   showCanvas(canvas);

  const { items: owned, shopItems } = profile;

  const items = (owned?.filter((item) => item?.image && item?.is_equipped && shopItems.room[item.slot]) ?? []) //фоновые предметы
    .sort((item1, item2) => {
      const weight1 = roomLayersWeights[item1.slot] ?? roomLayersWeights._defaultWeight;
      const weight2 = roomLayersWeights[item2.slot] ?? roomLayersWeights._defaultWeight;
      return weight1 - weight2;
    });
  const result = await loadImages(items.map((item) => item.image));

  if (!result.length) return console.error(`Can't load images: ${items.map((item) => item.image).join(', ')}`);

  const W = options?.size?.width;
  const H = options?.size?.height;

  const size = result[0].value;
  const scale = Math.max(size.width / W, size.height / H);
  const realSize = {
    width: size.width / scale,
    height: size.height / scale,
  };

  canvas.width = realSize.width;
  canvas.height = realSize.height;

  items.forEach(({ image }) => {
    const htmlImg = result.find((one) => one.value?.src === image).value;
    const { width, height } = htmlImg;
    ctx.drawImage(htmlImg, 0, 0, width, height, 0, 0, realSize.width, realSize.height);
  });

  /**
   * Place ElF
   */
  const data = { width: options.elfSize.width, height: options.elfSize.height };

  window.dispatchEvent(new CustomEvent('elf-controller:get-elf-snapshot', { detail: data }));
  const [{ value: elfImg }] = await loadImages([data.base64]);
  if (!elfImg) return console.error(`Can't get and load elf snapchat image`);
  const elfScale = 1;
  const elfW = elfImg.width * elfScale;
  const elfH = elfImg.height * elfScale;
  const dx = realSize.width / 2 - elfW / 2;
  const dy = realSize.height / 2 - elfH / 2 + options.elfSize.offset.y;
  ctx.drawImage(elfImg, 0, 0, elfImg.width, elfImg.height, dx, dy, elfW, elfH);
  /**
   */

  const base64 = canvas.toDataURL('image/png');
  // console.log(`base64`, base64);

  if (debug) {
    const image = new Image();
    image.src = base64;
    const w = window.open('');
    w.document.write(image.outerHTML);
    window.open(base64, '_blank');
  }

  return base64;
}

function downloadOne(base64) {
  const link = document.createElement('a');
  link.href = base64;
  link.download = 'test.png';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function showCanvas(canvas) {
  document.body.appendChild(canvas);
  canvas.style.position = 'fixed';
  canvas.style.top = '0';
  canvas.style.zIndex = '100';
  canvas.style.maxWidth = '100vw';
  canvas.style.opacity = '.8';
  //canvas.style.opacity = "1";
  canvas.style.pointerEvents = 'none';
}
